module.exports = __webpack_public_path__ + "img/navigate_dashboard_up.bfe3f3be.png";